import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const DEDUPE_WINDOW_MS = 1500;
const lastToastAtByKey = new Map();

function shouldSkipToast(type, title) {
  const key = `${type}:${String(title ?? '')}`;
  const now = Date.now();
  const lastAt = lastToastAtByKey.get(key);
  if (typeof lastAt === 'number' && now - lastAt < DEDUPE_WINDOW_MS) {
    return true;
  }
  lastToastAtByKey.set(key, now);
  return false;
}

const ICONS = {
  success: 'ri-check-line',
  error: 'ri-close-line',
  warning: 'ri-error-warning-line',
  info: 'ri-information-line'
};

function iconHtml(type) {
  return `<div class="tv-alert__badge tv-alert__badge--${type}">
    <span class="tv-alert__badge-pulse"></span>
    <span class="tv-alert__badge-inner"><i class="${ICONS[type] || ICONS.info}"></i></span>
  </div>`;
}

const baseOptions = {
  toast: false,
  position: 'center',
  showConfirmButton: false,
  showCloseButton: true,
  backdrop: 'rgba(15, 23, 42, 0.45)',
  allowOutsideClick: true,
  buttonsStyling: false,
  customClass: {
    popup: 'tv-alert',
    title: 'tv-alert__title',
    htmlContainer: 'tv-alert__html',
    closeButton: 'tv-alert__close',
    confirmButton: 'tv-alert__btn tv-alert__btn--primary',
    actions: 'tv-alert__actions',
    timerProgressBar: 'tv-alert__timer'
  },
  showClass: { popup: 'tv-alert--show' },
  hideClass: { popup: 'tv-alert--hide' }
};

function variant(type, title, extra = {}) {
  return Swal.fire({
    ...baseOptions,
    iconHtml: iconHtml(type),
    title,
    customClass: {
      ...baseOptions.customClass,
      popup: `tv-alert tv-alert--${type}`,
      icon: 'tv-alert__icon-wrap'
    },
    ...extra
  });
}

const AlertServie = {
  init(app) {},
  successMessage(title = 'Success') {
    if (shouldSkipToast('success', title)) return;
    return variant('success', title, {
      timer: 2400,
      timerProgressBar: true,
      showConfirmButton: false
    });
  },
  errorMessage(title = 'Error') {
    if (shouldSkipToast('error', title)) return;
    return variant('error', title, {
      showConfirmButton: true,
      confirmButtonText: 'Got it'
    });
  },
  warningMessage(title = 'Warning') {
    if (shouldSkipToast('warning', title)) return;
    return variant('warning', title, {
      showConfirmButton: true,
      confirmButtonText: 'Got it'
    });
  },
  infoMessage(title = 'Info') {
    if (shouldSkipToast('info', title)) return;
    return variant('info', title, {
      timer: 3000,
      timerProgressBar: true,
      showConfirmButton: false
    });
  },
  confirmMessage(title = 'Are you sure?', { type = 'info', html, confirmButtonText = 'Yes', cancelButtonText = 'Cancel' } = {}) {
    return variant(type, title, {
      html,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      customClass: {
        ...baseOptions.customClass,
        popup: `tv-alert tv-alert--${type}`,
        icon: 'tv-alert__icon-wrap',
        cancelButton: 'tv-alert__btn'
      }
    });
  }
};

export default AlertServie;
